import { useEffect } from "react";
import "../styles/loadingScreen.css";

const LoadingScreen = ({ setLoading }) => {
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1800);
    return () => clearTimeout(timer);
  }, [setLoading]);

  return (
    <div className="loading-screen">
      <img src="/LOGO_BLANCO.png" alt="Logo" />
      <div className="loading-bar" aria-hidden="true">
        <span />
      </div>
    </div>
  );
};

export default LoadingScreen;
